// Obfuscates the request payload so field values (phone numbers, email, etc.)
// are not readable at a glance in the browser Network tab.
//
// NOTE: this is a deterrent, not security. The key below ships to the browser,
// so a determined caller can still decrypt/replay. Real blocking needs a
// server-side challenge (Turnstile) or a CDN/WAF rule.

// Shared, non-secret key (also present on the server). AES-256-GCM, base64 (32 bytes).
const KEY_B64 = 'YqnOmkp8hoVHg7wZWr4Ff783QYF/6acitDUx4s6CmDI=';

export interface SecureEnvelope {
  iv: string;
  data: string;
}

function toB64(bytes: Uint8Array): string {
  let s = '';
  for (const b of bytes) s += String.fromCharCode(b);
  return btoa(s);
}

function fromB64(b64: string): Uint8Array {
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

// Returns an { iv, data } envelope, or null if Web Crypto is unavailable
// (caller should then fall back to sending the plain object).
export async function encryptBody(obj: unknown): Promise<SecureEnvelope | null> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) return null;
  try {
    const key = await subtle.importKey('raw', fromB64(KEY_B64), 'AES-GCM', false, ['encrypt']);
    const iv = globalThis.crypto.getRandomValues(new Uint8Array(12));
    const plaintext = new TextEncoder().encode(JSON.stringify(obj));
    const ct = new Uint8Array(await subtle.encrypt({ name: 'AES-GCM', iv }, key, plaintext));
    return { iv: toB64(iv), data: toB64(ct) };
  } catch {
    return null;
  }
}
